module.exports = __webpack_public_path__ + "static/img/5-1.30d38af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-5/5-1.jpg
// module id = 743
// module chunks = 1